import { CommonMessage } from "../../types";
import { EventBody, MessageComponent, MessageComponentProps } from "./Message";

const RawMessage: MessageComponent<CommonMessage> = ({
  message,
}: MessageComponentProps<CommonMessage>) => {
  return <EventBody>{JSON.stringify(message, null, 2)}</EventBody>;
};

export default RawMessage;
